import React from 'react';
import { ChevronLeft, ChevronRight } from 'lucide-react';

const TONE_BTN = {
  light: 'border-slate-300 text-slate-600 hover:bg-slate-50 disabled:opacity-40',
  dark: 'border-slate-700 text-slate-300 hover:bg-slate-800 disabled:opacity-40',
};
const TONE_ACTIVE = {
  light: 'bg-themePrimary text-white border-themePrimary',
  dark: 'bg-violet-600 text-white border-violet-600',
};
const TONE_TEXT = { light: 'text-slate-500', dark: 'text-slate-500' };

// One pagination convention — replaces 4 independently-implemented variants
// (prev/next only in some pages, numbered in others, each styled slightly differently).
const Pagination = ({ page, totalPages, onChange, tone = 'light', variant = 'simple' }) => {
  if (totalPages <= 1) return null;

  const base = 'px-3 py-1.5 text-sm border rounded-lg transition-colors disabled:cursor-not-allowed';

  if (variant === 'numbered') {
    const pages = [];
    const windowSize = 5;
    let start = Math.max(1, page - Math.floor(windowSize / 2));
    let end = Math.min(totalPages, start + windowSize - 1);
    start = Math.max(1, end - windowSize + 1);
    for (let p = start; p <= end; p++) pages.push(p);

    return (
      <div className="flex items-center gap-1.5">
        <button className={[base, TONE_BTN[tone]].join(' ')} disabled={page <= 1} onClick={() => onChange(page - 1)}>
          <ChevronLeft className="w-4 h-4" />
        </button>
        {pages.map((p) => (
          <button
            key={p}
            onClick={() => onChange(p)}
            className={[base, p === page ? TONE_ACTIVE[tone] : TONE_BTN[tone]].join(' ')}
          >
            {p}
          </button>
        ))}
        <button className={[base, TONE_BTN[tone]].join(' ')} disabled={page >= totalPages} onClick={() => onChange(page + 1)}>
          <ChevronRight className="w-4 h-4" />
        </button>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-3">
      <button className={[base, TONE_BTN[tone]].join(' ')} disabled={page <= 1} onClick={() => onChange(page - 1)}>
        Prev
      </button>
      <span className={['text-sm', TONE_TEXT[tone]].join(' ')}>
        Page {page} of {totalPages}
      </span>
      <button className={[base, TONE_BTN[tone]].join(' ')} disabled={page >= totalPages} onClick={() => onChange(page + 1)}>
        Next
      </button>
    </div>
  );
};

export default Pagination;
